import {
  Login,
  ForgetPass,
  ResetPass,
} from "../pages/Authentication/";
import Dashboard from "../pages/Dashboard/Dashboard";
import PredictionsPage from "../pages/Dashboard/PredictionsPage";
import ProfilePage from "../pages/Profile/ProfilePage";
import AuthRoute from "../Utils/RouteGuards/AuthRoutes";
import ProtectedRoute from "../Utils/RouteGuards/ProtectedRoutes";
import HelpPage from "../pages/Help/HelpPage";
import TermsPage from "../pages/Terms/TermsPage";
import PrivacyPage from "../pages/Privacy/PrivacyPage";
import DeleteAccountPage from "../pages/DeleteAccount/DeleteAccountPage";

const RoutesConfig = () => {
  const routes = [
    {
      path: "/",
      element: <Dashboard />,
    },
    {
      path: "/dashboard",
      element: <Dashboard />,
    },
    {
      path: "/help",
      element: <HelpPage />,
    },
    {
      path: "/terms",
      element: <TermsPage />,
    },
    {
      path: "/privacy",
      element: <PrivacyPage />,
    },
    // Auth-only pages (redirect to / if already logged in)
    {
      element: <AuthRoute />,
      children: [
        { path: "/login", element: <Login /> },
        { path: "/forget-password", element: <ForgetPass /> },
        { path: "/reset-password", element: <ResetPass /> },
      ],
    },

    // Protected pages (actual functional app area)
    {
      element: <ProtectedRoute />,
      children: [
        { path: "/profile", element: <ProfilePage /> },
        { path: "/predictions", element: <PredictionsPage /> },
        { path: "/delete-account", element: <DeleteAccountPage /> },
      ],
    },

    // 404 Fallback
    {
      path: "*",
      element: <h1 className="text-[var(--color-text)] text-center mt-[100px]">404 - Page Not Found</h1>,
    },
  ];

  return routes;
};

export default RoutesConfig;
